import React, { createContext, useCallback, useContext, useEffect } from "react";
//import { useOktaAuth } from "@okta/okta-react";
//import { AccessToken } from "@okta/okta-auth-js";
import { useLocation } from "react-router-dom";
import useSettingsStore from "common/store/SettingsStore";
import { LanguageContext } from "common/contexts/LanguageContext";
import { US_English_Locale } from "common/constants/GlobalValues";
import { useAuth0 } from '@auth0/auth0-react';

interface IAuthUser {
  givenName: string;
  familyName: string;
  email: string;
}
interface IAuthContext {
    isAuthenticatedUser: boolean;
    isPending: boolean;
    userInfo: IAuthUser | null;
    login: () => Promise<void>;
    finalizeLogin: () => Promise<void>;
    logoutUser: () => Promise<void>;
    getAccessToken: () => Promise<string | null>; // Use string instead of AccessToken
}

const AuthContext = createContext<IAuthContext>({
    isAuthenticatedUser: false,
    isPending: true,
    userInfo: null,
    login: async () => { },
    finalizeLogin: async () => { },
    logoutUser: async () => { },
    getAccessToken: async () => null,
});

interface IProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<IProps> = ({ children }) => {
  /*const { authState, oktaAuth } = useOktaAuth();*/
  const location = useLocation();
  const { settings } = useSettingsStore();
    const { selectedLanguageLocale } = useContext(LanguageContext);
    const { loginWithRedirect, logout, user, isAuthenticated, getAccessTokenSilently, isLoading } = useAuth0();

    const [state, setState] = React.useState<IAuthContext>({
        isAuthenticatedUser: false,
        isPending: true,
        userInfo: null,
        login: async () => { },
        finalizeLogin: async () => { },
        logoutUser: async () => { },
        getAccessToken: async () => null,
    });

  const replaceConfigLocale = (configStr: string) => {
    return configStr.replace("locale=en-us", `locale=${selectedLanguageLocale}`);
  };

  const finalizeLogin = async () => {
    try {
      //await oktaAuth.signInWithRedirect();
      //const isAuth = await oktaAuth.isAuthenticated();
      //console.log(`isAuth: ${isAuth}`);
      await loginWithRedirect();
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const login = async () => {
    try {
      localStorage.setItem("postAuthUrl", location.pathname);
      //const url =
      //  selectedLanguageLocale.toLowerCase() === US_English_Locale.toLowerCase()
      //    ? settings.myEmersonLogOnUrl
      //    : replaceConfigLocale(settings.myEmersonLogOnUrl);
      //window.location.href = url;
        loginWithRedirect({
            authorizationParams: {
                'ext-returnPath': '/en-us/',
                'ext-returnuri': 'https://q.wirelessplanning.emerson.com',
                'ext-redirectURI': 'https://q.wirelessplanning.emerson.com/en-us'
            }
        }); // Auth0's login method
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

    const logoutUser = async () => {
    try {
      //const logoutUrl = window.location.origin + "/account/logout/callback/";
      //await oktaAuth.signOut({ postLogoutRedirectUri: logoutUrl });

      //const url =
      //  selectedLanguageLocale.toLowerCase() === US_English_Locale.toLowerCase()
      //    ? settings.myEmersonLogOutUrl
      //    : replaceConfigLocale(settings.myEmersonLogOutUrl);
      //window.location.href = url;
        logout({ logoutParams: { returnTo: window.location.origin } });
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };


    const getAccessToken = useCallback(async () => {
        try {
            const token = await getAccessTokenSilently(); // Fetch the token as a string
            return token; // Return the token directly
        } catch (error) {
            return null;
        }
    }, [getAccessTokenSilently]);


  //useEffect(() => {
  //  if (authState?.isAuthenticated === true) {
  //    (async () => {
  //      try {
  //        const user = await oktaAuth.token.getUserInfo();
  //        console.log(`${user.given_name}  ${user.family_name?.charAt(0)}  ${user.given_name?.charAt(0)}`);
  //        if (user.given_name !== undefined && user.family_name !== undefined) {
  //          const newUser = {
  //            givenName: user.given_name,
  //            familyName: user.family_name,
  //          };
  //          setState((prev) => ({
  //            ...prev,
  //            user: newUser,
  //            isAuthenticated: authState?.isAuthenticated === true,
  //          }));
  //        }
  //      } catch (error) {
  //        console.error("Error during token retrieval:", error);
  //      }
  //    })();
  //  }
  //}, [authState?.isAuthenticated, oktaAuth]);

  useEffect(() => {
      if (!isLoading) {
          if (isAuthenticated && user) {
              const newUser = {
                  givenName: user.first_name || "",
                  familyName: user.last_name || "",
                  email: user.email || "",
              };
              setState((prev) => ({
                  ...prev,
                  userInfo: newUser,
                  isAuthenticatedUser: true,
              }));
          }
      }
  }, [isLoading, isAuthenticated, user, loginWithRedirect, state.isAuthenticatedUser]);

  //useEffect(() => {
  //  setState((prev) => ({ ...prev, isPending: authState?.isPending === true }));
  //}, [authState?.isPending]);

  return (
      <AuthContext.Provider value={{ ...state, login, logoutUser, finalizeLogin: finalizeLogin, getAccessToken }}>{children}</AuthContext.Provider>
  );
};

const useAuthContext = (): IAuthContext => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
};

export { AuthProvider, useAuthContext };
